import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Anderson Acevedo
 * 
 * @version jdesk_1.01.0003
 */
/**
 * Custom con funciones adicionales al Formulario
 **/
class CustomEspeciales extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm = this.initForm.bind(this);


        this.limpiarCampos = this.limpiarCampos.bind(this);

        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeAdicional = this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando = this.mostrarMensajeGenerando.bind(this);
        this.traerPropiedades = this.traerPropiedades.bind(this);
        this.sucesstraerPropiedades = this.sucesstraerPropiedades.bind(this);
        this.traerAdicionales = this.traerAdicionales.bind(this);
        this.traerCamposCod = this.traerCamposCod.bind(this);
        this.successAdicionales = this.successAdicionales.bind(this);
        this.successCamposCod = this.successCamposCod.bind(this);     

        this.sucessActualizar = this.sucessActualizar.bind(this);
        this.grabarEspecual = this.grabarEspecual.bind(this);

        //imprimir

        this.mostrarMensajeEmailFallo                         =this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado                         =this.mostrarMensajeEmailEnviado.bind(this);


        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.servicio = '';
        this.sucursal_ingreso = '';
        this.numero_decimales = 2;
        this.fila_seleccionada=[];
    }

    initForm() {
        console.log('Formulario CustomEspeciales,  @version: jdesk_1.01.0003, @author:Anderson Acevedo');
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.traerPropiedades();
        this.getField('radio_tipo').setDisabled(true);

        this.getField('codigo_articulo_aux').setOnChange((props) => {
            if (this.getField('codigo_articulo_aux').getValue() !== '' && this.getField('codigo_articulo_aux').getValue() !== ' ') {
                this.traerCamposCod();
                this.traerAdicionales();
            }
        });

        this.getField('nombre_grupo').setOnChange((props) => {
            this.getField('nombre_grupo').setError(false,'');
        });

        this.getField('nombre_subgrupo').setOnChange((props) => {
            this.getField('nombre_subgrupo').setError(false,'');
        });

        this.getField('nombre_marca').setOnChange((props) => {
            this.getField('nombre_marca').setError(false,'');
        });

        this.getField('nombre_tipo').setOnChange((props) => {
            this.getField('nombre_tipo').setError(false,'');
            this.getField('radio_tipo').setError(false,'');
            if(this.getField('nombre_tipo').getValue()!==''){
                if(this.getField('gravado_aux').getValue()==='S'){
                    this.getField('radio_tipo').setValue('gravado');
                }else if(this.getField('exento_aux').getValue()==='S'){
                    this.getField('radio_tipo').setValue('exento');
                }else if(this.getField('excluido_aux').getValue()==='S'){
                    this.getField('radio_tipo').setValue('excluido');
                }else{
                    this.getField('radio_tipo').setValue('');
                }
            }else{
                this.getField('radio_tipo').setValue('');
            }
        });

        this.getField('iva_ventas').setOnChange((props) => {
            this.getField('iva_ventas').setError(false,'');
            this.getField('iva_compras').setError(false,'');
        });

        this.getField('nombre_sucursal').setOnChange((props) => {
            this.getField('nombre_sucursal').setError(false,'');
        });

        this.getField('sede').setOnChange((props) => {
            this.getField('sede').setError(false,'');
            this.getField('nombre_proveedor').setError(false,'');
        });

 
        this.getField('bt_grabar').setClick(()=>{
            this.grabarEspecual();
        });

    }


    grabarEspecual(){
        if(this.getField('codigo_articulo_aux').valid() &&
        this.getField('codigo_articulo').valid() && 
        this.getField('presenta').valid() &&
        this.getField('nombre_articulo').valid() &&
        this.getField('alias').valid() &&
        this.getField('codigo_grupo').valid() &&
        this.getField('nombre_grupo').valid() &&
        this.getField('codigo_subgrupo').valid() &&
        this.getField('nombre_subgrupo').valid() &&
        this.getField('codigo_marca').valid() &&
        this.getField('nombre_marca').valid() &&
        this.getField('codigo_tipo_producto').valid() &&
        this.getField('nombre_tipo').valid() &&
        this.getField('codigo_iva').valid() &&
        this.getField('iva_ventas').valid() &&
        this.getField('iva_compras').valid() &&
        this.getField('precio').valid() &&
        this.getField('remision').valid() &&
        this.getField('codigo_sucursal').valid() &&
        this.getField('nombre_sucursal').valid() &&
        this.getField('item').valid() &&
        this.getField('nit').valid() &&
        this.getField('sede').valid() &&
        this.getField('nombre_proveedor').valid() &&
        this.getField('barras').valid()){

            let codigo = this.getField('codigo_articulo').getValue()
            + this.getField('codigo_sucursal').getValue()
            + this.getField('remision').getValue()
            + this.getField('item').getValue();

            let mensaje= "Código: " + codigo + "  ";
            mensaje = mensaje + ",Nombre: " + this.getField('nombre_articulo').getValue() + "  ";
            mensaje = mensaje + ",Alias: " + this.getField('alias').getValue() + ". ";
            mensaje = mensaje + "¿Confirma la grabación?";
            this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
            this.getField('confirmModalCustom').setClickDialog(() => { 
                    this.mostrarMensajeGuardando();

                    let datos={ datos: {
                        sucursal_ingreso:this.sucursal_ingreso,
                        codigo_articulo_aux:codigo,
                        presenta :this.getField('presenta').getValue(),
                        nombre_articulo :this.getField('nombre_articulo').getValue(),
                        alias :this.getField('alias').getValue(),
                        codigo_grupo :this.getField('codigo_grupo').getValue(),
                        codigo_subgrupo :this.getField('codigo_subgrupo').getValue(),
                        codigo_marca :this.getField('codigo_marca').getValue(),
                        radio_tipo :this.getField('radio_tipo').getValue(),
                        codigo_tipo_producto :this.getField('codigo_tipo_producto').getValue(),
                        codigo_iva :this.getField('codigo_iva').getValue(),
                        iva_ventas :this.getField('iva_ventas').getValue(),
                        iva_compras :this.getField('iva_compras').getValue(),
                        precio :this.getField('precio').getValue(),
                        remision :this.getField('remision').getValue(),
                        codigo_sucursal:this.getField('codigo_sucursal').getValue(),
                        item:this.getField('item').getValue(), 
                        nit:this.getField('nit').getValue(),
                        nombre_proveedor:this.getField('nombre_proveedor').getValue(),
                        barras :this.getField('barras').getValue(),
                    }};
                    this.generalFormatPmv = { tipo_servicio: 'inve-especiales', operacion: 'grabar', operacion_tipo: 'crear' };
                    this.service.send(
                    {
                            endpoint: this.constant.formConfiguration(),
                            method:'POST',
                            body: datos,
                            success: this.sucessActualizar,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                    });
            });
            this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField('confirmModalCustom').toggle(true);
        }else{
            this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
        }
    }

    sucessActualizar(data) {
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            else{
                this.mostrarMensajeAdicional('Grabado con éxito.');
                this.getField('codigo_articulo').setValue('');
                this.getField('presenta').setValue('');
                this.getField('nombre_articulo').setValue('');
                this.getField('alias').setValue('');
                this.getField('precio').setValue('');
                this.getField('codigo_articulo_aux').setValue('');

                this.limpiarCampos();
            }
        }else {
          if(data.estado_p===404) {
            this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
          }
          else {
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
          }
        }
      }



    traerPropiedades() {
        let datos = { datos: {
            sucursal_ingreso:this.sucursal_ingreso
        } };
        this.generalFormatPmv = { tipo_servicio: 'inve-especiales', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerPropiedades,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerPropiedades(data) {
        this.getField('confirmModalCustom').toggle(false);
        
        if (data.estado_p === 200) {
            this.numero_decimales = data.data.numero_decimales;
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }



    limpiarCampos() {
        this.getField('codigo_articulo').setError(false,'');
        this.getField('presenta').setError(false,'');
        this.getField('nombre_articulo').setError(false,'');
        this.getField('alias').setError(false,'');
        this.getField('codigo_grupo').setError(false,'');
        this.getField('codigo_subgrupo').setError(false,'');
        this.getField('codigo_tipo_producto').setError(false,'');
        this.getField('codigo_iva').setError(false,'');
        this.getField('barras').setError(false,'');

        this.getField('nombre_grupo').setError(false,'');
        this.getField('nombre_subgrupo').setError(false,'');
        this.getField('codigo_marca').setError(false,'');
        this.getField('nombre_marca').setError(false,'');
        this.getField('nombre_tipo').setError(false,'');
        this.getField('radio_tipo').setError(false,'');
        this.getField('iva_ventas').setError(false,'');
        this.getField('iva_compras').setError(false,'');
        this.getField('remision').setError(false,'');
        this.getField('codigo_sucursal').setError(false,'');
        this.getField('nombre_sucursal').setError(false,'');
        this.getField('item').setError(false,'');
        this.getField('nit').setError(false,'');
        this.getField('sede').setError(false,'');
        this.getField('nombre_proveedor').setError(false,'');

        this.getField('codigo_iva').setValue('');
        this.getField('codigo_tipo_producto').setValue('');
        this.getField('codigo_subgrupo').setValue('');
        this.getField('codigo_grupo').setValue('');

        this.getField('nombre_grupo').setValue('');
        this.getField('nombre_subgrupo').setValue('');
        this.getField('codigo_marca').setValue('');
        this.getField('nombre_marca').setValue('');
        this.getField('nombre_tipo').setValue('');
        this.getField('radio_tipo').setValue('');
        this.getField('iva_ventas').setValue('0');
        this.getField('iva_compras').setValue('0');
        this.getField('remision').setValue('');
        this.getField('codigo_sucursal').setValue('');
        this.getField('nombre_sucursal').setValue('');
        this.getField('item').setValue('');
        this.getField('nit').setValue('');
        this.getField('sede').setValue('');
        this.getField('nombre_proveedor').setValue('');
        this.getField('barras').setValue('');
    }

    traerCamposCod() {
        let errores = 0;

        if (!this.getField('codigo_articulo').valid())
            errores++;

        if (errores === 0) {
            let datos = {
                datos: {
                    codigo_articulo: this.getField("codigo_articulo").getValue(),
                }
            };

            this.generalFormatPmv = { tipo_servicio: 'inve-especiales', operacion: '1_camposCod', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successCamposCod,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        }
    }

    successCamposCod(data) { 
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.getField('presenta').setValue(data.data[0].presenta); 
            this.getField('nombre_articulo').setValue(data.data[0].nombre); 
            this.getField('alias').setValue(data.data[0].alias); 
            this.getField('precio').setValue(data.data[0].precio1); 
        } 
    }


    traerAdicionales() {
        let errores = 0;
        this.limpiarCampos();
    

        if (!this.getField('codigo_articulo').valid() && !this.getField('nombre_articulo').valid())
            errores++;

        if (errores === 0) {
            let datos = {
                datos: {
                    codigo_articulo: this.getField("codigo_articulo").getValue(),
                }
            };
            this.mostrarMensajeGenerando();
            this.generalFormatPmv = { tipo_servicio: 'inve-especiales', operacion: 'adicionales', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successAdicionales,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        }
    }


    successAdicionales(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.getField('codigo_grupo').setValue(data.data.codigo_grupo);
            this.getField('codigo_subgrupo').setValue(data.data.codigo_subgrupo);
            this.getField('codigo_tipo_producto').setValue(data.data.codigo_tipo_producto);
            this.getField('codigo_iva').setValue(data.data.codigo_iva);

            this.getField('nombre_grupo').setValue(data.data.nombre_grupo);
            this.getField('nombre_subgrupo').setValue(data.data.nombre_subgrupo);
            this.getField('nombre_tipo').setValue(data.data.nombre_tipo);
            this.getField('iva_ventas').setValue(data.data.iva_ventas);
            this.getField('iva_compras').setValue(data.data.iva_compras);
            this.getField('nit').setValue(data.data.nit);
            this.getField('nombre_proveedor').setValue(data.data.nombre_proveedor);
            this.getField('sede').setValue(data.data.sede);

            if(data.data.gravado==='S'){
                this.getField('radio_tipo').setValue('gravado');
            }else if(data.data.exento==='S'){
                this.getField('radio_tipo').setValue('exento');
            }else if(data.data.excluido==='S'){
                this.getField('radio_tipo').setValue('excluido');
            }else{
                this.getField('radio_tipo').setValue('');
            }
        } else {
           this.mostrarMensajeNoHayDatos();
        }
    }


    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > this.numero_decimales) {
                number = number.toFixed(this.numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


    mostrarMensajeGuardando(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

    }

    mostrarMensajeNoHayDatos() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    //mensajes correo

    mostrarMensajeEmailEnviado() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailFallo() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }


}
FormJaivana.addController("inve-especiales", CustomEspeciales);
export default CustomEspeciales